import { Dropdown, DropdownProps } from 'antd';
import { ToolbarButton, ToolbarButtonProps } from './ToolbarButton';
import styles from '../RichTextEditor.module.scss';
import classNames from 'classnames';

interface SelectedItem {
  label: string;
  icon?: React.ReactNode;
}

export interface ToolbarDropdownButtonProps
  extends ToolbarButtonProps,
    Pick<DropdownProps, 'trigger' | 'overlay'> {
  selectedItem?: SelectedItem;
}

export const renderMenuItem = (
  icon: React.ReactNode | null,
  label: string,
  shortcut?: string,
) => (
  <div className={styles.menuItem}>
    {icon && <span className={styles.menuIcon}>{icon}</span>}
    <span className={styles.menuLabel}>{label}</span>
    {shortcut && <span className={styles.menuShortcut}>{shortcut}</span>}
  </div>
);

export function ToolbarDropdownButton(props: ToolbarDropdownButtonProps) {
  const {
    trigger = ['click'],
    overlay,
    selectedItem,
    className,
    visibleText,
    ...buttonProps
  } = props;

  return (
    <Dropdown overlay={overlay} trigger={trigger}>
      <ToolbarButton
        {...buttonProps}
        icon={selectedItem?.icon || buttonProps.icon}
        visibleText={selectedItem?.label ?? visibleText}
        className={classNames(styles.dropdownButton, className)}
      />
    </Dropdown>
  );
}
